import React from 'react'
import { Skeleton } from '../../ui/skeleton'

export const PropertySidebarLoadingContent = () => (
  <div className="flex h-full flex-col">
    <div className="border-b border-border px-5 py-6">
      <div className="mb-5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-5 rounded-full" />
          <span className="text-xl font-semibold text-foreground">Properties</span>
        </div>
        <Skeleton className="h-4 w-4 rounded-full" />
      </div>
      <Skeleton className="h-10 w-full rounded-xl" />
    </div>

    <div className="border-b border-border px-5 py-4">
      <div className="mb-2 flex items-start justify-between">
        <div className="space-y-2">
          <Skeleton className="h-4 w-24 rounded" />
          <Skeleton className="h-4 w-20 rounded" />
        </div>
        <Skeleton className="h-4 w-14 rounded" />
      </div>
    </div>

    <div className="flex-1 space-y-2 overflow-hidden px-4 py-4">
      <Skeleton className="mb-3 h-4 w-28 rounded" />
      {Array.from({ length: 8 }).map((_, index) => (
        <Skeleton key={index} className="h-11 w-full rounded-xl" />
      ))}
    </div>

    <div className="border-t border-border px-5 py-5">
      <Skeleton className="h-4 w-28 rounded" />
    </div>
  </div>
)

export default PropertySidebarLoadingContent
